import { connect } from 'react-redux';
import type { State } from '../../../modules/reducers';
import { toggleTheme } from '../../../modules/Theme/actions';
import ThemeSwitcher from './ThemeSwitcher';
import type { StateProps } from './ThemeSwitcher';

const mapStateToProps = (state: State): StateProps => ({
  locale: state.localization.locale,
  theme: state.theme,
});

const mapDispatchToProps = {
  toggleTheme,
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeSwitcher);
